import { GateWay } from './GateWay';
class Main extends GateWay {
    constructor(path) {
        super('', path);
    }
}

export default new Main();
